// WEB-469 (BC-1): Sentry SDK bootstrap for the browser client (Better Stack
// ingest) — crash reporting + session-replay, mirroring the backend's
// instrument.ts (WEB-470/BC-2) env-gate.
//
// CRITICAL — env-gated, no-op without a DSN: initSentry() calls Sentry.init
// ONLY when VITE_SENTRY_DSN is present. VITE_SENTRY_DSN IS already set in
// the Railway frontend service; local dev without the var stays a no-op.
// Never hardcode a DSN here — it always comes from the environment via
// src/config/sentry-config.ts.
//
// PII — session-replay records the DOM, so replayIntegration is configured
// mask-everything (maskAllText/maskAllInputs/blockAllMedia): our forms carry
// lead-gen PII (email, name, phone) and payment fields (card number), and
// this is the safe default rather than an allowlist that could miss a field.
// beforeSend additionally scrubs the *event payload* itself (see
// src/utils/scrubPii.ts) — replay masking and payload scrubbing are two
// separate channels and both need it.
import * as Sentry from '@sentry/react';
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from '@/config/sentry-config';
import { scrubPii } from '@/utils/scrubPii';

export function initSentry(): void {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    // Error tracking + replay only for now, no performance tracing (mirrors
    // BC-2 scope) — free-quota conscious, revisit if perf visibility is needed.
    tracesSampleRate: 0,
    // 10% of ordinary sessions, 100% of sessions that hit an error — keeps
    // replay volume affordable while guaranteeing a replay for every crash.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend: scrubPii,
  });
}
